(function () {
  var BREAKPOINTS = [
    { attr: 'widescreen',   query: '(min-width: 1920px)' },
    { attr: 'desktopLarge', query: '(min-width: 1440px)' },
    { attr: 'desktop',      query: '(min-width: 1024px)' },
    { attr: 'tablet',       query: '(min-width: 768px)' },
    { attr: 'mobile',       query: '(min-width: 0px)' }
  ];

  function applyBackground(el) {
    var color = el.getAttribute('data-bckg-color') || '';
    var url = '';

    for (var j = 0; j < BREAKPOINTS.length; j++) {
      var bp = BREAKPOINTS[j];
      var src = el.getAttribute('data-bckg-' + bp.attr);
      if (src && window.matchMedia(bp.query).matches) {
        url = src;
        break;
      }
    }

    if (!url) return;

    var style = color
      ? 'background: ' + color + ', url(' + url + ')'
      : 'background-image: url(' + url + ')';

    if (el.getAttribute('style') !== style) {
      el.setAttribute('style', style);
    }
  }

  function init() {
    var elements = document.querySelectorAll('[data-bckg-lazy]');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(applyBackground);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          applyBackground(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
